import React from "react";
import './loader.css';

const Loader = () => {
  return (
    <div id="loader-overlay">
      <div className="spinner-border" role="status"></div>
    </div>
  );
};
export default Loader;
